import React from "react";
import Lot from "./components/sell";
const View = (props) =>{
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const data = params.get("data");


  return (
    <div style={{paddingTop: 5}}>
     
      <Lot data={data} />
    </div>
  );
}

export default View;
